// https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/fullToolbar.js
export const toolbarConfig = [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    // [{ 'align': ''}, { align: "center" }, { 'align': 'justify'}, { 'align': 'right' }],
];
